
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/images/LOGOCENTRALDEMOLITION.png" 
                alt="Central Demolition and Services" 
                className="h-10 w-auto"
              />
              <div className="ml-3">
                <h2 className="text-xl font-bold text-white">Central Demolition</h2>
                <p className="text-sm text-gray-300">Services You Can Trust</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Professional demolition and general labor services across New England. 
              Committed to safety, respect, and excellence in every project.
            </p>
            <div className="flex space-x-4">
              <div>
                <p className="font-semibold">Call us today:</p>
                <a href="tel:857-777-4300" className="text-blue-400 text-lg hover:text-blue-300 transition-colors cursor-pointer">857-777-4300</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Services</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-gray-300">
              <p>
                <i className="ri-mail-line mr-2"></i>
                contact@central-demolition.com
              </p>
              <p>
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:857-777-4300" className="hover:text-white transition-colors cursor-pointer">857-777-4300</a>
              </p>
              <p>
                <i className="ri-time-line mr-2"></i>
                Mon–Fri: 7:00 AM – 6:00 PM
              </p>
              <p>
                <i className="ri-map-pin-line mr-2"></i>
                PO Box - 321 Stoughton, MA 02072
              </p>
              <p>
                <i className="ri-map-pin-line mr-2"></i>
                Serving All New England
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Central Demolition & Services. All rights reserved.
          </p>
          <div className="flex space-y-2 md:space-y-0 md:space-x-6 mt-4 md:mt-0 flex-col md:flex-row">
            <span className="text-gray-400 text-sm">
              Made by <a href="https://luanvalle.com.br" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors">LV Services</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
